import React from "react"
import { 
    StyledArticleAuthorContainer,
    StyledAuthorImage,
    StyledAuthorDetailsContainer,
    StyledAuthorName,
    StyledAuthorRole
} from "./styled";

const ArticleAuthor = ({ avatar, name, role }) => {
  return (
    <StyledArticleAuthorContainer>
        <StyledAuthorImage
          alt={avatar.alternativeText}
          src={avatar.formats.thumbnail.url}
        />
      <StyledAuthorDetailsContainer>
        <StyledAuthorName>
          {name}
        </StyledAuthorName>
        <StyledAuthorRole>
          {role}
        </StyledAuthorRole>
      </StyledAuthorDetailsContainer>
    </StyledArticleAuthorContainer>
  )
}

export default ArticleAuthor
